const actions = {
  fetchPermissions: 'FETCH::PERMISSIONS',
  setPermissions: 'SET::PERMISSIONS'
}

export const getPermissions = state => state
export default actions



// WEBPACK FOOTER //
// ./src/store/permissions/actions.js